export default __webpack_public_path__ + "static/media/skillIcon.c0c54a24.svg";